import styled from "styled-components";

const ModalBody = styled.div``;

const SelectContainer = styled.div`
	margin-bottom: 10px;
`;

export { ModalBody, SelectContainer };
